import "./AddSingleProduct.scss";
import { BackButton } from "../../../../../components/primaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { pathConstants } from "../../../../../routes/pathContants";

const AddSingleProduct = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`add-single-product-page ${globalStyles.pagePaddings}`}
    >
      <div>
        <BackButton
          onClick={() => navigate(pathConstants.INVENTORY_PRODUCTS)}
        />
      </div>

      <div className="add-single-product-page__content">
        <div className="add-single-product-page__content-options">
          <secondaryComponents.WalletOption
            title="Product"
            onChange={() => {
              navigate(pathConstants.INVENTORY_PRODUCTS_ADD_SINGLE);
            }}
            name="inventory_option"
            checked={pathname === "/app/inventory/products/add/single"}
            value={"products"}
          />
          <secondaryComponents.WalletOption
            title="Services"
            onChange={(option) => {
              navigate(pathConstants.INVENTORY_SERVICE_CREATE);
            }}
            name="inventory_option"
            checked={pathname === "/app/inventory/services/add/single"}
            value={"services"}
          />
        </div>
        {/* <div className="add-single-product-page__content-header">
          {option !== "products" ? (
            <>
              <h3 className="font-weight-semibold">Create single service</h3>
              <p>Please provide the following information about your service</p>
            </>
          ) : (
            <>
              <h3 className="font-weight-semibold">Create single product</h3>
              <p>Please provide the following information about your product</p>
            </>
          )}
        </div> */}

        <Outlet />
      </div>
    </motion.div>
  );
};

export default AddSingleProduct;
